import { PageTimeTracker } from '../PageTimeTracker/PageTimeTracker.tsx';

export const Analytics = () => <PageTimeTracker />;
